import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

export const PaypalRequestsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.paypalRequests.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
